import { FC } from 'react';
import { useQuery } from 'react-query';
import { isNotEmpty, QUERIES } from '../../../../../_dashboard/helpers';
import { useListView } from '../core/ListViewProvider';
import { getOneById } from '../../../../services/common_requests';
import { initialPaymentMethod } from '../core/_models';
import { PaymentMethodEditModalForm } from './PaymentMethodEditModalForm';

const PaymentMethodEditModalFormWrapper: FC = () => {
  const { itemIdForUpdate } = useListView();
  const enabledQuery = isNotEmpty(itemIdForUpdate);

  const { isLoading, data: paymentMethod } = useQuery(
    `${QUERIES.PAYMENT_METHODS_LIST}-payment-method-${itemIdForUpdate}`,
    () => getOneById(itemIdForUpdate, '/payment-methods'),
    { cacheTime: 0, enabled: enabledQuery }
  );

  if (!itemIdForUpdate) {
    return <PaymentMethodEditModalForm isPaymentMethodLoading={false} PaymentMethod={initialPaymentMethod} />;
  }

  if (isLoading) return null;

  return (
    <PaymentMethodEditModalForm
      isPaymentMethodLoading={isLoading}
      PaymentMethod={paymentMethod || initialPaymentMethod}
    />
  );
};

export { PaymentMethodEditModalFormWrapper };
